module.exports = __webpack_public_path__ + "img/hic-lung-cancer-male.61bf5bbe.png";